<div class="contact-form-container">
  <div class="heading-container flex-row flex-justify-space-between flex-align-center">
    <h1 mat-dialog-title translate="AUCTION_CONTACT.DIALOG.HEADER"></h1>
    <button mat-button mat-dialog-close class="close-button" aria-label="Cancel">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <form [formGroup]="form" (ngSubmit)="recaptchaExecute()">
    <mat-form-field class="form-field">
      <mat-label translate="AUCTION_CONTACT.DIALOG.EMAIL_INPUT_LABEL"> </mat-label>
      <input matInput formControlName="email" name="email" type="email" required />
    </mat-form-field>
    <mat-form-field class="form-field" appearance="fill">
      <mat-label translate="AUCTION_CONTACT.DIALOG.MESSAGE_INPUT_LABEL"></mat-label>
      <textarea matInput formControlName="message" name="message" class="message-input" required> </textarea>
    </mat-form-field>

    <div class="btn-container flex-row px-gap-10">
      <div class="flex-col flex-grow">
        <button
          mat-stroked-button
          mat-dialog-close
          type="button"
          translate="AUCTION_CONTACT.DIALOG.CANCEL_BUTTON"
        ></button>
      </div>
      <div class="flex-col flex-grow">
        <button
          mat-raised-button
          type="submit"
          color="primary"
          [disabled]="form.invalid"
          translate="AUCTION_CONTACT.DIALOG.SUBMIT_BUTTON"
        ></button>
      </div>
    </div>
    <gb-recaptcha-privacy-terms></gb-recaptcha-privacy-terms>
    <gb-front-invisible-recaptcha (recaptchaSuccess)="onSubmit($event)"> </gb-front-invisible-recaptcha>
  </form>
</div>
